import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_ORDERING_PRACTITIONERS } from "../../config/connString";
import useAxios from "../../utils/useAxios";
import decodedUserDetails from "utils/decodedUserDetails";

const createOrderingPractitioner = createAsyncThunk(
  "ordering-practitioners/create-ordering-practitioner",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();

      const response = await api.post(URL_ORDERING_PRACTITIONERS, {
        firstName: data.firstName,
        lastName: data.lastName,
        clientId: clientId,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { createOrderingPractitioner };
